<template>
  <div class="wrap">
    <div class="img-wrap">
      <img :src="src" alt="">
    </div>
    <div class="tip">
      长按上方图片发送给好友
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  data() {
    return {
      src: ''
    }
  },
  created() {
    this.src = this.$route.query.url
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .wrap
    background #333
    min-height 100vh
  .tip
    position fixed
    left 0
    bottom 0
    width 100%
    background $color-theme
    line-height size(90)
    text-align center
    font-size size(34)
    color #fff
  .img-wrap
    padding size(30) size(30) size(90+30)
    img
      display block
      width 100%
</style>



// WEBPACK FOOTER //
// src/components/personal/certification/popup-share.vue